import { defineComponent as _defineComponent } from 'vue'
import DxpCarouselProductCard from '../shared/DxpCarouselProductCard.vue';
import LayoutA from 'JS/dxp/components/shared/story-item-carousels/LayoutA.vue';
import LayoutB from 'JS/dxp/components/shared/story-item-carousels/LayoutB.vue';
import LayoutC from 'JS/dxp/components/shared/story-item-carousels/LayoutC.vue';
import VIntersectionObserver from 'JS/components/VIntersectionObserver.vue';
import { computed } from 'vue';
import { createPromoDataAttributes } from 'JS/utilities/analytics';
import { getPriceMode } from 'JS/types/Product';
import { getStoryOrItemCarouselLink } from 'JS/dxp/types/widgets/computed';
import { ItemCarouselWidgetResource } from 'JS/dxp/types/widgets/item-carousel-widget';
import { StoryAndItemCarouselLayout } from 'JS/dxp/types/widgets/shared';
import { useProductCarouselTracking } from 'JS/dxp/composables/product-carousel-tracking';


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemCarouselWidget',
  props: {
    widget: null
  },
  setup(__props: any) {

const props = __props as {
	widget: ItemCarouselWidgetResource;
}



const layoutComponent = computed(() => {
	switch (props.widget.widget.layout) {
		case StoryAndItemCarouselLayout.A:
			return LayoutA;
		case StoryAndItemCarouselLayout.B:
			return LayoutB;
		case StoryAndItemCarouselLayout.C:
			return LayoutC;
		default:
			return null;
	}
});

const link = computed(() => getStoryOrItemCarouselLink(props.widget.widget));

const layoutPromoDataAttrs = computed(() => {
	if (!link.value) {
		return null;
	}

	const { title, layout } = props.widget.widget;

	return createPromoDataAttributes({
		promoId: link.value.url.replace('https://www.farmandfleet.com', ''),
		promoName: title,
		creativeSlot: 'dxp_item_carousel_0',
		creativeName: `dxp_item_carousel_${StoryAndItemCarouselLayout[layout]}`,
	});
});

const { trackView, trackClick } = useProductCarouselTracking(() => {
	const { carouselType, carouselName, products } = props.widget.data;

	return {
		type: carouselType,
		name: carouselName ?? 'DXP Item Widget',
		products: products.map(product => ({
			blainNumber: product.blainNumber,
			vendorBrand: product.brand,
			productName: product.name,
			price: product.price,
			belowMap: product.price.isBelowMAP,
			priceMode: getPriceMode(product.price)
		})),
	};
});


return { __sfc: true,props, layoutComponent, link, layoutPromoDataAttrs, trackView, trackClick, DxpCarouselProductCard, VIntersectionObserver }
}

})